import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Header } from './components/Header';
import { LandingPage } from './components/LandingPage';
import { SelectPartnersPage } from './components/SelectPartnersPage';
import { DirectDisplayPartnersPage } from './components/DirectDisplayPartnersPage';
import { DirectDisplayOptimizer } from './components/DirectDisplayOptimizer';
import { ScenarioDetails } from './components/ScenarioDetails';
import { RFPScorecard } from './components/RFPScorecard';
import { DealsPage } from './components/DealsPage';
import { ChannelScenarios } from './components/ChannelScenarios';
import { SelectChannelsPage } from './components/SelectChannelsPage';
import { SocialPartnersOptimizer } from './components/SocialPartnersOptimizer';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/partners" element={<SelectPartnersPage />} />
          <Route path="/partners/display" element={<DirectDisplayPartnersPage />} />
          <Route path="/partners/display/optimize" element={<DirectDisplayOptimizer />} />
          <Route path="/partners/display/optimize/scenario/:id" element={<ScenarioDetails />} />
          <Route path="/partners/display/rfp-scorecard" element={<RFPScorecard />} />
          <Route path="/partners/display/deals" element={<DealsPage />} />
          <Route path="/channels" element={<ChannelScenarios />} />
          <Route path="/channels/select/:id" element={<SelectChannelsPage />} />
          <Route path="/partners/social/optimize" element={<SocialPartnersOptimizer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
